var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 30,
    height: 30,
    viewBox: "0 0 172 172",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.778,35.75307c-1.24987,-3.4744 -2.5112,-6.97747 -2.53413,-7.02333c-0.602,-1.34733 -1.9952,-2.19587 -3.46293,-2.0468c-0.9288,0.07453 -22.90467,1.96653 -36.98573,13.28987c-7.3616,6.79973 -22.06187,46.55467 -22.06187,80.926c0,0.60773 0.1548,1.19827 0.45867,1.72573c10.15373,17.83067 37.83427,22.4976 44.14093,22.69827c0.04013,0.00573 0.07453,0.00573 0.10893,0.00573c1.11227,0 2.15573,-0.5332 2.8208,-1.43333l6.82267,-9.24213c-11.27173,-1.71427 -13.30707,-3.95027 -13.78293,-4.3c-2.5456,-1.8748 -4.42613,-4.50067 -2.14427,-7.81453c1.7544,-2.57427 5.4352,-3.4228 8.256,-1.97227c2.8896,1.34733 10.62387,5.68173 33.58587,5.56707c22.80147,-0.0688 32.81187,-4.84467 32.9552,-4.94787c3.82987,-1.72573 6.81693,-1.0148 8.68027,1.54227c2.2188,3.48013 0.6364,5.83653 -1.89773,7.7056c-0.47587,0.34973 -1.62827,1.33013 -13.73707,4.1968l6.73667,9.25933c0.65933,0.90587 1.70853,1.43333 2.8208,1.43333c0.04013,0 0.07453,0 0.10893,-0.00573c6.3124,-0.20067 33.99293,-4.8676 44.14093,-22.69827c0.30387,-0.52747 0.45867,-1.118 0.45867,-1.72573c0,-34.3656 -14.70027,-74.12053 -22.24533,-81.06933c-13.8976,-11.16853 -35.87347,-13.06053 -36.80227,-13.1408c-1.46773,-0.12613 -2.86093,0.7052 -3.46293,2.0468c-0.02293,0.04587 -1.24987,3.60627 -2.43667,7.04053c0,0 -9.35107,-1.37027 -15.31947,-1.37027c-5.9684,0 -15.222,1.35307 -15.222,1.35307zM63.06667,108.93333c-6.33533,0 -11.46667,-7.64253 -11.46667,-17.0796c0,-9.43707 5.13133,-17.0796 11.46667,-17.0796c6.35827,-0.946 11.32907,7.64253 11.46667,17.0796c0,9.43707 -5.13133,17.0796 -11.46667,17.0796zM108.93333,108.93333c-6.33533,0 -11.46667,-7.69413 -11.46667,-17.1828c0,-9.48867 5.13133,-17.1828 11.46667,-17.1828c6.33533,0 11.46667,7.69413 11.46667,17.1828c0,9.48867 -5.13133,17.1828 -11.46667,17.1828z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.86fc4dc51271bfd68b0be1f245df57b4.svg";
export { ForwardRef as ReactComponent };